/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var VideoApp = (() => {
    var play = (container) => {
      if (!container) return;

      pause(container);

      let video = null;
      if (window.innerWidth < 768)
        video = container.querySelector('[js-mobile-video] video');
      else
        video = container.querySelector('[js-desktop-video] video');

      if (video) {
        video.closest('[js-video]').classList.add('playing');
        video.play();
      }
    }

    var pause = (container) => {
      if (!container) return;

      container.querySelectorAll('[js-video] video').forEach(video => {
        video.pause();
        video.closest('[js-video]').classList.remove('playing');
      });
    }

    var initialize = () => {
      document.querySelectorAll('[js-new-video-container][autoplay="true"]').forEach(element => {
        if (element.getAttribute('autoplay') === 'true') {
          play(element);
        } else {
          pause(element);
        }
      });

      document.querySelectorAll('[js-new-video-container] [js-video-play]').forEach(element => {
        element.addEventListener('click', () => {
          play(element.closest('[js-new-video-container]'));
        });
      });

      document.querySelectorAll('[js-new-video-container] [js-video] video').forEach(element => {
        element.addEventListener('click', () => {
          // pause(element.closest('[js-new-video-container]'));
        });
        element.addEventListener('ended', () => {
          play(element.closest('[js-new-video-container]'));
        });
      });


    }

    return {
      init: initialize
    }
  })();


  // [BD feat] Sticky ATC button on PDP
  var StickyATCButton = (() => {
    let stickyATCContainer = null;
    let submitButton = null;

    var setVariantDetails = () => {
      const productForm = document.querySelector('body.template-product form[data-product-form] [data-product-select]');
      if (!productForm) return;
      const currentVariantId = productForm.value;
      stickyATCContainer.querySelectorAll('[js-variant-info]').forEach(element => {
        element.classList.remove('selected');
        if (element.getAttribute('data-variant-id') == currentVariantId) {
          element.classList.add('selected');
        }
      });
    }
    var show = () => {
      if (!stickyATCContainer) return;
      setVariantDetails();
      document.body.classList.add('has-product-sticky-atc');
    }
    var hide = () => {
      if (!stickyATCContainer) return;
      document.body.classList.remove('has-product-sticky-atc');
    }
    var checkMainATCIsInViewport = () => {
      const mainATCButton = document.querySelector('body.template-product form[data-product-form] [data-add-to-cart][type="submit"]');
      if (!mainATCButton) return;
      if (mainATCButton.getBoundingClientRect().top > (-1 * mainATCButton.getBoundingClientRect().height)) {
        hide();
      } else {
        show();
      }
    }
    var submit = () => {
      if (!submitButton) return;
      const productForm = document.querySelector('body.template-product form[data-product-form]');
      if (!productForm) return;
      window.scrollTo(0, window.scrollY + productForm.getBoundingClientRect().top - 100);
    }
    var initialize = () => {
      stickyATCContainer = document.querySelector('[js-product-sticky-add-to-cart]');
      if (!stickyATCContainer) return;

      const productForm = document.querySelector('body.template-product form[data-product-form] [data-product-select]');
      if (!productForm) return;
      productForm.addEventListener('change', () => {
        setVariantDetails();
      });

      submitButton = stickyATCContainer.querySelector('[js-sticky-atc-button]');
      if (!submitButton) return;
      submitButton.addEventListener('click', () => {
        submit();
      });
    }
    return {
      init: initialize,
      check: checkMainATCIsInViewport
    }
  })();


  var ShowMoreLessApp = (() => {
    var open = (container) => {
      if (!container) return;
      const element = container.querySelector('[js-show-more-content]');
      if (!element) return;
      let duration = parseInt(container.getAttribute('data-duration'));
      duration = (duration>0)?duration:300;
      element.classList.add('open');
      element.style.maxHeight = element.scrollHeight + 'px';
      setTimeout(() => {
        element.style.maxHeight = 'fit-content';
      }, duration);
    }
    var close = (container) => {
      if (!container) return;
      const element = container.querySelector('[js-show-more-content]');
      if (!element) return;
      element.style.maxHeight = element.scrollHeight + 'px';
      setTimeout(() => {
        element.classList.remove('open');
        element.style.maxHeight = '0px';
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-container] [js-show-more]').forEach(showMoreButton => {
        showMoreButton.addEventListener('click', () => {
          open(showMoreButton.closest('[js-container]'));
        });
      });
      document.querySelectorAll('[js-container] [js-show-less]').forEach(showLessButton => {
        showLessButton.addEventListener('click', () => {
          close(showLessButton.closest('[js-container]'));
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var BDMarqueeApp = (() => {
    var intervalIdList = {};
    var play = (element, index) => {
      if (!element || element.classList.contains('playing')) return;
      element.classList.add('playing');
      const intervalId = setInterval(() => {
        let scrollLeft = element.scrollLeft;
        scrollLeft = (scrollLeft-1>=0)?(scrollLeft-1):(element.scrollWidth-element.offsetWidth);
        element.scrollTo(scrollLeft, 0);
      }, 15);
      intervalIdList[index] = intervalId;
    }
    var pause = (element, index) => {
      element.classList.remove('playing');
      clearInterval(intervalIdList[index]);
    }
    var initialize = () => {
      document.querySelectorAll('[js-bd-marquee]').forEach((element, index) => {
        element.scrollTo(element.scrollWidth - element.offsetWidth, 0);
        play(element, index);
        element.addEventListener('mouseover', () => {
          pause(element, index);
        });
        element.addEventListener('mouseleave', () => {
          play(element, index);
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var AnchorToATCButtonApp = (() => {
    var goToATC = () => {
      const productForm = document.querySelector('body.template-product form[data-product-form]');
      if (!productForm) return;
      window.scrollTo(0, window.scrollY + productForm.getBoundingClientRect().top - 100);
    }
    var initialize = () => {
      document.querySelectorAll('[js-anchor-to-atc]').forEach(element => {
        element.addEventListener('click', () => {
          goToATC();
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var BDQuizApp = (() => {
    let quiz = null;

    var isCheckInput = (element) => {
      return element.type === 'checkbox' || element.type === 'radio';
    }

    var setProgress = () => {
      if (!quiz) return;
      let currentIndex = parseInt(localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-current-step-index`));
      if (isNaN(currentIndex)) currentIndex = 1;
      let percent = 1;
      const currentBlock = quiz.querySelector('.block.active');
      if (!currentBlock) return;
      if (parseInt(currentBlock.getAttribute('data-step-percent')) > 0) {
        percent = parseInt(currentBlock.getAttribute('data-step-percent'));
      } else if (currentBlock.hasAttribute('js-email-input-block')) {
        percent = 100;
      } else {
        let startPercent = 1;
        let endPercent = 0; 
        let flag = false;
        let leftCount = 0;
        let totalCount = 0;
        quiz.querySelectorAll('.block').forEach(block => {
          if (flag && endPercent > 0) return;
          const value = parseInt(block.getAttribute('data-step-percent'));
          totalCount++;
          if (!isNaN(value) && !flag) {
            startPercent = value;
            totalCount = 0;
          }
          if (flag) {
            leftCount++;
          }
          if (block.classList.contains('active')) {
            flag = true;
          }
          if (flag && !isNaN(value)) {
            endPercent = value;
          }
        });
        percent = parseInt(endPercent - (endPercent - startPercent) / totalCount * leftCount);
      }
      const progressValue = quiz.querySelector('[js-progress-value]');
      if (progressValue) progressValue.innerHTML = percent;
      const progressBar = quiz.querySelector('[js-progress-bar]');
      if (progressBar) progressBar.style.setProperty('--progress', percent+'%');
      const backButton = quiz.querySelector('[js-back]');
      const backButtonATag = quiz.querySelector('[js-back-a-tag]');
      if (backButton && backButtonATag) {
        if (currentIndex == 1 && !currentBlock.classList.contains('loading')) {
          backButton.classList.add('hidden');
          backButtonATag.classList.remove('hidden');
        }
        else {
          backButton.classList.remove('hidden');
          backButtonATag.classList.add('hidden');
        }
      }
    }

    var showBlock = (index=1, needLoading=false, isNext=false) => {
      if (!quiz) return;
      if (index < 1 || index > parseInt(quiz.getAttribute('data-total-blocks-count'))) return;
      const currentBlock = quiz.querySelector('.block.active');
      if (!currentBlock) return;

      const finishedBlock = quiz.querySelector('[js-finished-block]');
      if (!finishedBlock) return;

      if (localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-finished`) === 'true') {
        currentBlock.classList.remove('active');
        finishedBlock.classList.add('active');
        return;
      }

      let loadingDelay = 0;
      if (needLoading && currentBlock.hasAttribute('need-loading')) {
        loadingDelay = 1000;
        currentBlock.classList.add('loading');
      }
      setTimeout(() => {
        if (isNext) {
          let valueList = {
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
          }
          let data_point_value_per_each_1 = parseFloat(currentBlock.getAttribute('data-point-value-per-each-1'));
          const data_point_type_per_each_1 = currentBlock.getAttribute('data-point-type-per-each-1');
          data_point_value_per_each_1 = isNaN(data_point_value_per_each_1) ? 0 : data_point_value_per_each_1;

          let data_point_value_per_each_2 = parseFloat(currentBlock.getAttribute('data-point-value-per-each-2'));
          const data_point_type_per_each_2 = currentBlock.getAttribute('data-point-type-per-each-2');
          data_point_value_per_each_2 = isNaN(data_point_value_per_each_2) ? 0 : data_point_value_per_each_2;

          let data_point_type_more_two = parseFloat(currentBlock.getAttribute('data-point-type-more-two'));
          const data_point_value_more_two = currentBlock.getAttribute('data-point-value-more-two');
          data_point_value_per_each_2 = isNaN(data_point_value_per_each_2) ? 0 : data_point_value_per_each_2;

          let checkedCount = 0;
          currentBlock.querySelectorAll('[data-point-value]:has(input:checked)').forEach(element => {
            checkedCount++;
            let value = parseFloat(element.getAttribute('data-point-value'));
            value = isNaN(value) ? 0 : value;
            valueList[element.getAttribute('data-point-type')] += value;
            valueList[data_point_type_per_each_1] += data_point_value_per_each_1;
            valueList[data_point_type_per_each_2] += data_point_value_per_each_2;
          });
          if (checkedCount >= 2) {
            valueList[data_point_type_more_two] += data_point_value_more_two;
          }

          const temperatureInput = currentBlock.querySelector('input[js-temperature-input]');
          if (temperatureInput) {
            if (temperatureInput.value < 36.6) {
              let flag = true;
              quiz.querySelectorAll('input[data-medication]:checked').forEach(medicationElement => {
                if (medicationElement.getAttribute('data-medication') !== 't4') {
                  flag = false;
                }
              });
              if (quiz.querySelectorAll('input[data-medication]:checked').length > 0 && flag) {
                valueList['1'] += 2;
              }
              if (quiz.querySelectorAll('input[data-medication]:checked').length == 0) {
                valueList['2'] += 2;
              }
            }
          }
          
          for (let key in valueList) {
            localStorage.setItem(`quiz-${quiz.getAttribute('data-section-id')}-block-${currentBlock.getAttribute('data-block-index')}-score-${key}`, valueList[key]);
          }
        }
        currentBlock.classList.remove('active');
        currentBlock.classList.remove('loading');
        const block = quiz.querySelector(`.block[data-block-index="${index}"]`);
        if (block) {
          if (isNext) {
            localStorage.setItem(`quiz-${quiz.getAttribute('data-section-id')}-block-${index}-back-index`, currentBlock.getAttribute('data-block-index'));
            block.setAttribute('data-back-index', currentBlock.getAttribute('data-block-index'));
          }
          block.classList.add('active');
          const inputElement = quiz.querySelector('.block[data-block-index="1"] input[type="text"]');
          if (inputElement) {
            const value = localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-block-1-${inputElement.getAttribute('data-name')}`);
            quiz.querySelectorAll('[data-template]').forEach(element => {
              element.innerHTML = String(element.getAttribute('data-template')).replace('((user_name))', value);
            });
          }
        }
        localStorage.setItem(`quiz-${quiz.getAttribute('data-section-id')}-current-step-index`, index);
        setProgress();
      }, loadingDelay);
    }

    var next = (button=null) => {
      if (!quiz) return;
      if (button && button.classList.contains('disabled')) {
        return;
      }
      setTimeout(() => {
        const currentIndex = parseInt(localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-current-step-index`));
        let nextIndex = currentIndex + 1;
        const currentBlock = quiz.querySelector(`.block[data-block-index="${currentIndex}"]`);
        if (!currentBlock) return;
        if (button && button.getAttribute('data-jump-to') && button.getAttribute('data-jump-to') !== '' && currentBlock.querySelectorAll('[data-ignore-jump]:checked').length === 0) {
          const nextBlock = quiz.querySelector(`.block[data-block-id="${button.getAttribute('data-jump-to')}"]`);
          if (nextBlock) {
            nextIndex = parseInt(nextBlock.getAttribute('data-block-index'));
          }
        }
        currentBlock.querySelectorAll('input').forEach(inputElement => {
          let value = inputElement.value;
          if (isCheckInput(inputElement)) {
            value = inputElement.checked;
          }
          localStorage.setItem(`quiz-${quiz.getAttribute('data-section-id')}-block-${currentIndex}-${inputElement.getAttribute('data-name')}`, value);
          const displayText = inputElement.closest('.block').querySelector('.display-text');
          if (displayText) {
            displayText.innerHTML = String(displayText.getAttribute('data-template')).replace('((user_name))', value);
            nextFlag = false;
            currentBlock.classList.add('loading');
            setProgress();
          }
        });
        showBlock(nextIndex, true, true);
      });
    }

    var back = () => {
      if (!quiz) return;
      let prevFlag = true;
      const currentIndex = parseInt(localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-current-step-index`));
      const currentBlock = quiz.querySelector(`.block[data-block-index="${currentIndex}"]`);
      let prevIndex = currentIndex - 1;
      if (currentBlock && currentBlock.getAttribute('data-back-index') && currentBlock.getAttribute('data-back-index') !== '') {
        prevIndex = parseInt(currentBlock.getAttribute('data-back-index'));
      }
      if (currentBlock) {
        currentBlock.querySelectorAll('input').forEach(input => {
          if (!currentBlock.classList.contains('loading')) {
            if (isCheckInput(input)) {
              input.checked = false;
            } else {
              input.value = '';
            }
            const nextButton = currentBlock.querySelector('.next-button[js-next]');
            if (nextButton) nextButton.classList.add('disabled');
          } else {
            prevFlag = false;
            currentBlock.classList.remove('loading');
            setProgress();
          }
          input.removeAttribute('disabled');
          localStorage.removeItem(`quiz-${quiz.getAttribute('data-section-id')}-block-${currentIndex}-${input.getAttribute('data-name')}`);
        });
        for (let i = 1; i <= 5; i++) {
          let value = parseInt(localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-block-${currentBlock.getAttribute('data-block-index')}-score-${i}`));
          value = isNaN(value) ? 0 : value;
          localStorage.setItem(`quiz-${quiz.getAttribute('data-section-id')}-block-${currentBlock.getAttribute('data-block-index')}-score-${i}`, 0);
        }
      }
      if (prevFlag)
        showBlock(prevIndex);
    }

    var userBlockInputValueChanged = (element) => {
      if (!element) return;
      const container = element.closest('.block');
      if (!container) return;
      const nextButton = container.querySelector('[js-next]');
      if (!nextButton) return;
      if (element.value == '') {
        nextButton.classList.add('disabled');
      } else {
        nextButton.classList.remove('disabled');
      }
    }

    var questionsBlockInputValueChanged = (element) => {
      if (!element) return;
      const container = element.closest('.block');
      if (!container) return;
      const nextButton = container.querySelector('.next-button[js-next]');
      if (!nextButton) return;
      let flag = false;
      container.querySelectorAll('input').forEach(inputElement => {
        if (inputElement.checked === true && !container.querySelector('[js-temperature-input]')) {
          flag = true;
        }
        if (inputElement.hasAttribute('js-temperature-input') && inputElement.value !== '') {
          flag = true;
        }
      });
      if (!flag) {
        nextButton.classList.add('disabled');
      } else {
        nextButton.classList.remove('disabled');
      }
    }

    var setAllInputValues = () => {
      quiz.querySelectorAll('.block[data-block-index] input').forEach(inputElement => {
        const blockIndex = inputElement.closest('.block').getAttribute('data-block-index');
        const value = localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-block-${blockIndex}-${inputElement.getAttribute('data-name')}`);
        if (isCheckInput(inputElement)) {
          inputElement.checked = (value==='true') ? true : false;
        } else {
          inputElement.value = value;
        }
        if ((!isCheckInput(inputElement) && inputElement.value !== '') || (isCheckInput(inputElement) && inputElement.checked === true)) {
          const nextButton = inputElement.closest('.block').querySelector('.next-button');
          if (nextButton && !inputElement.closest('.block').querySelector('[js-temperature-input]')) nextButton.classList.remove('disabled');
        }
      });
    }

    var setBackIndexToBlocks = () => {
      quiz.querySelectorAll('.block[data-block-index]').forEach(block => {
        block.setAttribute('data-back-index', localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-block-${block.getAttribute('data-block-index')}-back-index`));
      });
    }

    var temperatureInputChanged = (input, flag) => {
      if (!input) return;
      const minValue = parseInt(input.getAttribute('min'));
      const maxValue = parseInt(input.getAttribute('max'));
      const value = parseInt(input.value);
      const container = input.closest('.content');
      const invalidText = container.querySelector('[js-invalid-text]');
      const validText = container.querySelector('[js-valid-text]');
      if (!invalidText || !validText) return;
      validText.classList.remove('hidden');
      invalidText.classList.add('hidden');
      if (container && container.querySelector('input[type="radio"]') && !flag) {
        container.querySelector('input[type="radio"]').checked = false;
      }
      if (value >= minValue && value <= maxValue) {
        next(input);
      } else if (value < minValue) {
        invalidText.innerHTML = invalidText.getAttribute('data-min-invalid-text');
        invalidText.classList.remove('hidden');
        validText.classList.add('hidden');
      } else if (value > maxValue) {
        invalidText.innerHTML = invalidText.getAttribute('data-max-invalid-text');
        invalidText.classList.remove('hidden');
        validText.classList.add('hidden');
      } else if (flag) {
        next(input);
      }
    }

    var displayResult = () => {
      let maxValue = 0;
      let semiMaxValue = 0;
      let firstIndex = 0;
      let secondIndex = 0;
      let totalValue = 0;
      for (let i = 1; i <= 5; i++) {
        let value = parseFloat(localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-total-score-${i}`));
        totalValue += value;
        if (value > maxValue) {
          maxValue = value;
          firstIndex = i;
        } else if (value > semiMaxValue) {
          semiMaxValue = value;
          secondIndex = i;
        }
      }
      const loadingBlock = quiz.querySelector('[js-final-loading-block]');
      const finishedBlock = quiz.querySelector('[js-finished-block]');
      let resultBlock = null;
      if (quiz.querySelector('.quiz-body .block--break_flow .answer>input').checked === true) {
        resultBlock = quiz.querySelector(`[js-result-block="1-${firstIndex}-${secondIndex}"]`);
      } else {
        if (totalValue >= 3) {
          resultBlock = quiz.querySelector(`[js-result-block="2-2"]`);
        } else {
          resultBlock = quiz.querySelector(`[js-result-block="2-0"]`);
        }
      }
      if (!loadingBlock || !resultBlock || !finishedBlock) return;
      loadingBlock.classList.remove('active');
      finishedBlock.classList.remove('active');
      resultBlock.classList.add('active');
      setTimeout(() => {
        window.scrollTo(0, 0);
      });
      localStorage.setItem(`quiz-${quiz.getAttribute('data-section-id')}-finished`, "true");
    }

    var submit = () => {
      let scoreList = {
        '1': 0,
        '2': 0,
        '3': 0,
        '4': 0,
        '5': 0
      }
      for (let i = 1; i <= parseInt(quiz.getAttribute('data-total-blocks-count')); i++) {
        for (let j = 1; j <= 5; j++) {
          let value = parseFloat(localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-block-${i}-score-${j}`));
          value = (isNaN(value)) ? 0 : value;
          scoreList[j] += value;
        }
      }
      for (key in scoreList) {
        localStorage.setItem(`quiz-${quiz.getAttribute('data-section-id')}-total-score-${key}`, scoreList[key]);
      }

      let maxValue = 0;
      let semiMaxValue = 0;
      let firstIndex = 0;
      let secondIndex = 0;
      let totalValue = 0;
      for (let i = 1; i <= 5; i++) {
        let value = parseFloat(localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-total-score-${i}`));
        totalValue += value;
        if (value > maxValue) {
          maxValue = value;
          firstIndex = i;
        } else if (value > semiMaxValue) {
          semiMaxValue = value;
          secondIndex = i;
        }
      }

      const customDataInput = quiz.querySelector('.block--email_input .content .embed-code--wrapper form div[data-testid="form-component"] input[type="text"]');
      if (!customDataInput) return;

      let resultBlock = null;
      if (quiz.querySelector('.quiz-body .block--break_flow .answer>input').checked === true) {
        resultBlock = quiz.querySelector(`[js-result-block="1-${firstIndex}-${secondIndex}"]`);
      } else {
        if (totalValue >= 3) {
          resultBlock = quiz.querySelector(`[js-result-block="2-2"]`);
        } else {
          resultBlock = quiz.querySelector(`[js-result-block="2-0"]`);
        }
      }
      customDataInput.value = `${resultBlock.querySelector('[js-bd-quiz-result-product] .featured-product__title') ? resultBlock.querySelector('[js-bd-quiz-result-product] .featured-product__title').innerHTML : ''} ${resultBlock.querySelector('[js-bd-quiz-result-product]~[js-bd-quiz-result-product] .featured-product__title') ? ', ' + resultBlock.querySelector('[js-bd-quiz-result-product]~[js-bd-quiz-result-product] .featured-product__title').innerHTML : ''}`;
      const inputEvent = new Event('input', { bubbles: true });
      customDataInput.dispatchEvent(inputEvent);

      const klaviyoButton = quiz.querySelector('.block--email_input .content .embed-code--wrapper form div[data-testid="form-component"] button[type="button"]');
      if (!klaviyoButton) return;

      setTimeout(() => {
        klaviyoButton.click();
      });

      const emailInput = quiz.querySelector('.block--email_input .content .embed-code--wrapper form div[data-testid="form-component"] input[type="email"]');
      if (!isValidEmail(emailInput.value)) return;

      const finalLoadingBlock = quiz.querySelector('[js-final-loading-block]');
      const currentBlock = quiz.querySelector('.block.active');
      if (!finalLoadingBlock || !currentBlock) return;
      currentBlock.classList.remove('active');
      finalLoadingBlock.classList.add('active');

      setTimeout(() => {
        displayResult();
      }, 4000);
    }

    var reset = () => {
      localStorage.clear();
      quiz.querySelectorAll('input').forEach(element => {
        if (isCheckInput(element)) {
          element.checked = false;
        } else {
          element.value = '';
        }
      });
      quiz.querySelectorAll('.block--user [js-next], .block--questions:has(.next-button) [js-next]').forEach(element => {
        element.classList.add('disabled');
      });
      showBlock();
    }

    var isValidEmail = (email) => {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    }

    var initialize = () => {
      quiz = document.querySelector('[js-bd-quiz]');
      if (!quiz) return;
      if (!localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-current-step-index`)) {
        localStorage.setItem(`quiz-${quiz.getAttribute('data-section-id')}-current-step-index`, 1);
      }
      setAllInputValues();
      setBackIndexToBlocks();
      showBlock(localStorage.getItem(`quiz-${quiz.getAttribute('data-section-id')}-current-step-index`));
      quiz.querySelectorAll('.block [js-next]').forEach(nextButton => {
        nextButton.addEventListener('click', () => {
          if (nextButton.closest('.block').classList.contains('loading')) return;
          const temperatureInput = nextButton.closest('.block').querySelector('[js-temperature-input]');
          if (temperatureInput) {
            temperatureInputChanged(temperatureInput, nextButton.classList.contains('answer'));
          } else {
            next(nextButton);
          }
        });
      });
      quiz.querySelectorAll('[js-back]').forEach(backButton => {
        backButton.addEventListener('click', () => {
          back();
        });
      });
      quiz.querySelectorAll('.block--user input').forEach(element => {
        element.addEventListener('input', () => {
          userBlockInputValueChanged(element);
        });
      });
      quiz.querySelectorAll('.block--questions:has(.next-button) input:not([js-temperature-input])').forEach(element => {
        element.addEventListener('change', () => {
          questionsBlockInputValueChanged(element);
        });
      });
      quiz.querySelectorAll('[js-temperature-input]').forEach(element => {
        element.addEventListener('input', () => {
          questionsBlockInputValueChanged(element);
        });
      });
      quiz.querySelectorAll('[js-submit]').forEach(element => {
        element.addEventListener('click', () => {
          if (!element.classList.contains('disabled')) {
            submit();
          }
        });
      });
      quiz.querySelectorAll('[js-bd-quiz-result-product] form input').forEach(element => {
        element.addEventListener('change', () => {
          if (element.checked === true) {
            const input = element.closest('form').querySelector('[data-product-select]');
            if (input) {
              input.value = element.getAttribute('data-variant-id');
            }
          }
        });
      });
      quiz.querySelectorAll('[js-go-to-result]').forEach(element => {
        element.addEventListener('click', () => {
          displayResult();
        });
      });
      quiz.querySelectorAll('[js-reset]').forEach(element => {
        element.addEventListener('click', () => {
          reset();
        });
      });
      const observer = new MutationObserver((mutationsList, observer) => {
        const input = quiz.querySelector('.block--email_input .content .embed-code--wrapper form div[data-testid="form-component"] input');
        if (input) {
          input.addEventListener('input', function(event) {
            if (input.value !== '') {
              quiz.querySelectorAll('[js-submit]').forEach(element => {
                element.classList.remove('disabled');
              });
              quiz.querySelectorAll('.block--email_input .footer-text').forEach(element => {
                element.classList.remove('hidden');
              });
            } else {
              quiz.querySelectorAll('[js-submit]').forEach(element => {
                element.classList.add('disabled');
              });
              quiz.querySelectorAll('.block--email_input .footer-text').forEach(element => {
                element.classList.add('hidden');
              });
            }
          });
          input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              const submitButton = quiz.querySelector('[js-submit]');
              if (submitButton && !submitButton.classList.contains('disabled')) {
                submit();
              }
            }
          });
          observer.disconnect(); // stop observing after input is found
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });      
    }
    return {
      init: initialize
    }
  })();


  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      const cartDrawer = document.querySelector('#cart-drawer');
      console.log("cartDrawer", cartDrawer);
      if (cartDrawer) {
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              const cartItemsHolder = document.getElementById('cartItemsHolder');
              const cartDrawerDivider = document.querySelector('.cart-drawer__divider');
              console.log("cartItemsHolder", cartItemsHolder);
              console.log("cartDrawerDivider", cartDrawerDivider);
              if (cartItemsHolder) {
                if (cartItemsHolder.children.length >= 1) {
                  cartDrawerDivider.style.display = 'block';
                } else {
                  cartDrawerDivider.style.display = 'none';
                }
              }
            }
          });
        });

        observer.observe(cartDrawer, { childList: true, subtree: true });
      }
    }, 300);
    VideoApp.init();
    StickyATCButton.init();
    ShowMoreLessApp.init();
    BDMarqueeApp.init();
    AnchorToATCButtonApp.init();
    BDQuizApp.init();
  });

  window.addEventListener('scroll', () => {
    StickyATCButton.check();
  });



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
